import React from 'react';

import { WorkScheduleContent } from './components/WorkScheduleContent/WorkScheduleContent';
import { useWorkScheduleController } from './hooks/useWorkScheduleController';

export const WorkSchedule = ({
  companyId,
  renderCompanySelect,
  renderToolbar,
}) => {
  const workSchedule = useWorkScheduleController({ companyId });

  return (
    <WorkScheduleContent
      {...workSchedule}
      renderCompanySelect={renderCompanySelect}
      renderToolbar={renderToolbar}
    />
  );
};
